import {
    GET_ACTIVITIES_FAIL,
    GET_ACTIVITIES_REQUEST,
    GET_ACTIVITY_LIST,
    GET_ACTIVITIES_SUCCESS,
    SET_ACTIVITIES_OPTION
} from "../constants/activitiesConstants";
import {requestApi} from "../../utils/utils";

export const getActivitiesByTrip = (tripId) => async (dispatch) => {
    dispatch({type: GET_ACTIVITIES_REQUEST});

    try {
        const {data: {Extras, Complimentary}} = await requestApi(`/get-activities`, 'GET', {tripId});

        dispatch({
            type: GET_ACTIVITIES_SUCCESS,
            payload: {
                extra: Object.values(Extras),
                complimentary: Object.values(Complimentary)
            }
        });
    } catch (e) {
        dispatch({type: GET_ACTIVITIES_FAIL, error: e});
    }

};
export const getActivityList = () => async (dispatch) => {
    dispatch({type: GET_ACTIVITY_LIST});

    try {
        const {data: {Extras, Complimentary}} = await requestApi(`/get-activity-list`, 'GET');

        dispatch({
            type: GET_ACTIVITIES_SUCCESS,
            payload: {
                extra: Object.values(Extras),
                complimentary: Object.values(Complimentary)
            }
        });
    } catch (e) {
        dispatch({type: GET_ACTIVITIES_FAIL, error: e});
    }

};

export const setActivitiesOption = (option) => (dispatch) => {
    sessionStorage.setItem('activitiesOption', option);
    dispatch({
        type: SET_ACTIVITIES_OPTION,
        payload: option
    });
};